import { AICC_PROMPT_DEFAULT_EFFORT } from "constants/aiccPrompt";

// 🔴 A reasoning model takes the effort instead of a temperature; only `none` leaves the temperature meaningful.
export const appliesTemperature = (reasoningEffort?: string) =>
  !reasoningEffort || reasoningEffort === AICC_PROMPT_DEFAULT_EFFORT;
